export enum FormControlType {
    text = 'text',
    number = 'number',
    select = 'select',
    autoComplete = 'autocomplete',
    radio = 'radio',
    date = 'date',    
    object = 'object',
    textArea = 'textarea',
    table = 'table',
    checkbox = 'checkbox',
    inlineArray = 'inlineArray'
}

export enum FormControlSize {
    twoColumns = '2',
    threeColumns = '3',
    fourColumns = '4',
    sixColumns = '6',
    eightColumns = '8',
    tenColumns = '10',
    twelveColumns = '12',
}
